/**
 * Super-admin translations, one folder per area (ADMIN_<AREA> keys), merged per
 * language. Written by scratchpad admin_i18n_base.py; areas are edited in place.
 */
import SHELL_EN from './shell/en.json';
import SHELL_FR from './shell/fr.json';
import SHELL_ES from './shell/es.json';
import SHELL_AR from './shell/ar.json';
import OVERVIEW_EN from './overview/en.json';
import OVERVIEW_FR from './overview/fr.json';
import OVERVIEW_ES from './overview/es.json';
import OVERVIEW_AR from './overview/ar.json';
import VENDORS_EN from './vendors/en.json';
import VENDORS_FR from './vendors/fr.json';
import VENDORS_ES from './vendors/es.json';
import VENDORS_AR from './vendors/ar.json';
import VENDOREDIT_EN from './vendoredit/en.json';
import VENDOREDIT_FR from './vendoredit/fr.json';
import VENDOREDIT_ES from './vendoredit/es.json';
import VENDOREDIT_AR from './vendoredit/ar.json';
import USERS_EN from './users/en.json';
import USERS_FR from './users/fr.json';
import USERS_ES from './users/es.json';
import USERS_AR from './users/ar.json';
import SPACES_EN from './spaces/en.json';
import SPACES_FR from './spaces/fr.json';
import SPACES_ES from './spaces/es.json';
import SPACES_AR from './spaces/ar.json';
import QUEUE_EN from './queue/en.json';
import QUEUE_FR from './queue/fr.json';
import QUEUE_ES from './queue/es.json';
import QUEUE_AR from './queue/ar.json';
import CATALOG_EN from './catalog/en.json';
import CATALOG_FR from './catalog/fr.json';
import CATALOG_ES from './catalog/es.json';
import CATALOG_AR from './catalog/ar.json';
import BILLING_EN from './billing/en.json';
import BILLING_FR from './billing/fr.json';
import BILLING_ES from './billing/es.json';
import BILLING_AR from './billing/ar.json';
import SALES_EN from './sales/en.json';
import SALES_FR from './sales/fr.json';
import SALES_ES from './sales/es.json';
import SALES_AR from './sales/ar.json';
import PLANS_EN from './plans/en.json';
import PLANS_FR from './plans/fr.json';
import PLANS_ES from './plans/es.json';
import PLANS_AR from './plans/ar.json';
import COSTS_EN from './costs/en.json';
import COSTS_FR from './costs/fr.json';
import COSTS_ES from './costs/es.json';
import COSTS_AR from './costs/ar.json';
import SIGNUPS_EN from './signups/en.json';
import SIGNUPS_FR from './signups/fr.json';
import SIGNUPS_ES from './signups/es.json';
import SIGNUPS_AR from './signups/ar.json';
import CRM_EN from './crm/en.json';
import CRM_FR from './crm/fr.json';
import CRM_ES from './crm/es.json';
import CRM_AR from './crm/ar.json';
import TOOLS_EN from './tools/en.json';
import TOOLS_FR from './tools/fr.json';
import TOOLS_ES from './tools/es.json';
import TOOLS_AR from './tools/ar.json';
import USAGE_EN from './usage/en.json';
import USAGE_FR from './usage/fr.json';
import USAGE_ES from './usage/es.json';
import USAGE_AR from './usage/ar.json';
import NETWORK_EN from './network/en.json';
import NETWORK_FR from './network/fr.json';
import NETWORK_ES from './network/es.json';
import NETWORK_AR from './network/ar.json';

export const ADMIN_TRANSLATIONS: Record<"en" | "fr" | "es" | "ar", Record<string, unknown>> = {
  en: { ...(SHELL_EN as Record<string, unknown>), ...(OVERVIEW_EN as Record<string, unknown>), ...(VENDORS_EN as Record<string, unknown>), ...(VENDOREDIT_EN as Record<string, unknown>), ...(USERS_EN as Record<string, unknown>), ...(SPACES_EN as Record<string, unknown>), ...(QUEUE_EN as Record<string, unknown>), ...(CATALOG_EN as Record<string, unknown>), ...(BILLING_EN as Record<string, unknown>), ...(SALES_EN as Record<string, unknown>), ...(PLANS_EN as Record<string, unknown>), ...(COSTS_EN as Record<string, unknown>), ...(SIGNUPS_EN as Record<string, unknown>), ...(CRM_EN as Record<string, unknown>), ...(TOOLS_EN as Record<string, unknown>), ...(USAGE_EN as Record<string, unknown>), ...(NETWORK_EN as Record<string, unknown>) },
  fr: { ...(SHELL_FR as Record<string, unknown>), ...(OVERVIEW_FR as Record<string, unknown>), ...(VENDORS_FR as Record<string, unknown>), ...(VENDOREDIT_FR as Record<string, unknown>), ...(USERS_FR as Record<string, unknown>), ...(SPACES_FR as Record<string, unknown>), ...(QUEUE_FR as Record<string, unknown>), ...(CATALOG_FR as Record<string, unknown>), ...(BILLING_FR as Record<string, unknown>), ...(SALES_FR as Record<string, unknown>), ...(PLANS_FR as Record<string, unknown>), ...(COSTS_FR as Record<string, unknown>), ...(SIGNUPS_FR as Record<string, unknown>), ...(CRM_FR as Record<string, unknown>), ...(TOOLS_FR as Record<string, unknown>), ...(USAGE_FR as Record<string, unknown>), ...(NETWORK_FR as Record<string, unknown>) },
  es: { ...(SHELL_ES as Record<string, unknown>), ...(OVERVIEW_ES as Record<string, unknown>), ...(VENDORS_ES as Record<string, unknown>), ...(VENDOREDIT_ES as Record<string, unknown>), ...(USERS_ES as Record<string, unknown>), ...(SPACES_ES as Record<string, unknown>), ...(QUEUE_ES as Record<string, unknown>), ...(CATALOG_ES as Record<string, unknown>), ...(BILLING_ES as Record<string, unknown>), ...(SALES_ES as Record<string, unknown>), ...(PLANS_ES as Record<string, unknown>), ...(COSTS_ES as Record<string, unknown>), ...(SIGNUPS_ES as Record<string, unknown>), ...(CRM_ES as Record<string, unknown>), ...(TOOLS_ES as Record<string, unknown>), ...(USAGE_ES as Record<string, unknown>), ...(NETWORK_ES as Record<string, unknown>) },
  ar: { ...(SHELL_AR as Record<string, unknown>), ...(OVERVIEW_AR as Record<string, unknown>), ...(VENDORS_AR as Record<string, unknown>), ...(VENDOREDIT_AR as Record<string, unknown>), ...(USERS_AR as Record<string, unknown>), ...(SPACES_AR as Record<string, unknown>), ...(QUEUE_AR as Record<string, unknown>), ...(CATALOG_AR as Record<string, unknown>), ...(BILLING_AR as Record<string, unknown>), ...(SALES_AR as Record<string, unknown>), ...(PLANS_AR as Record<string, unknown>), ...(COSTS_AR as Record<string, unknown>), ...(SIGNUPS_AR as Record<string, unknown>), ...(CRM_AR as Record<string, unknown>), ...(TOOLS_AR as Record<string, unknown>), ...(USAGE_AR as Record<string, unknown>), ...(NETWORK_AR as Record<string, unknown>) },
};
